"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-3de95cd6"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "registration-steps flex-column mb-0"
};
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", { class: "title mb-0" }, "oplusへようこそ！", -1 /* HOISTED */));
const _hoisted_4 = { class: "registration-content" };
const _hoisted_5 = ["aria-hidden"];
const _hoisted_6 = ["aria-hidden"];
const _hoisted_7 = ["aria-hidden"];
const _hoisted_8 = { class: "registration-footer d-flex flex-column-center" };
const _hoisted_9 = { class: "flex-justify-between" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-left" }, null, -1 /* HOISTED */));
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* HOISTED */));
const _hoisted_14 = {
    key: 0,
    class: "text-center policy-text"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("a", {
    href: "/terms",
    target: "_blank",
    class: "oplus-color"
}, "利用規約", -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("a", {
    href: "/privacy",
    target: "_blank",
    class: "oplus-color"
}, "個人情報取り扱い", -1 /* HOISTED */));
const vue_3 = require("vue");
const UserRegistrationForm_vue_1 = __importDefault(require("./components/UserRegistrationForm.vue"));
const GroupRegistrationForm_vue_1 = __importDefault(require("./components/GroupRegistrationForm.vue"));
const AlertModal_vue_1 = __importDefault(require("../../../vue/AlertModal.vue"));
const provider_1 = require("../../../provider/provider");
const registrationRequest_1 = require("../../../requests/registrationRequest");
const RegistrationData_vue_1 = __importDefault(require("./components/RegistrationData.vue"));
const TOTAL_STEPS = 3;
exports.default = (0, vue_1.defineComponent)({
    __name: 'RegistrationApp',
    setup(__props) {
        const alertModal = (0, vue_3.ref)(null);
        const userFormRef = (0, vue_3.ref)(null);
        const viewModel = (0, vue_3.inject)(provider_1.registrationViewModelInjectKey);
        const userViewModel = (0, vue_3.inject)(provider_1.userRegistrationViewModelInjectKey);
        const groupViewModel = (0, vue_3.inject)(provider_1.groupRegistrationViewModelInjectKey);
        const userPresenter = (0, vue_3.inject)(provider_1.userRegistrationPresenterInjectKey);
        const groupPresenter = (0, vue_3.inject)(provider_1.groupRegistrationPresenterInjectKey);
        const showPrevButton = (0, vue_3.computed)(() => {
            if (!viewModel?.value) {
                return false;
            }
            return viewModel.value.step > 1;
        });
        const showCompleteButton = (0, vue_3.computed)(() => {
            if (!viewModel?.value) {
                return false;
            }
            return viewModel.value.step === TOTAL_STEPS || !viewModel.value.isOwner;
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return viewModel?.value.isLoading ? 'loading' : '';
        });
        const step = (0, vue_3.computed)(() => {
            return viewModel?.value.step ?? 1;
        });
        const wrapperClass = (0, vue_3.computed)(() => {
            return {
                'footer-height': showCompleteButton.value, // add class when policy text is shown
                'show-steps': viewModel?.value?.isOwner,
            };
        });
        async function submitForms() {
            // User form
            if (viewModel?.value.step === 1) {
                if (viewModel.value.isLoading) {
                    return;
                }
                // Submit user form only if not owner
                if (!viewModel.value.isOwner) {
                    userPresenter?.setIsLoading(true);
                    userFormRef.value?.submitForm();
                    return;
                }
                if (!userPresenter?.validate()) {
                    await (0, vue_3.nextTick)();
                    scrollToInvalidInput();
                    return;
                }
                userPresenter?.nextStep();
                return;
            }
            // Group form
            else if (viewModel?.value.step === 2) {
                if (!groupPresenter.validate() || viewModel.value.isLoading) {
                    await (0, vue_3.nextTick)();
                    scrollToInvalidInput();
                    return;
                }
                groupPresenter?.nextStep();
            }
            else {
                // Submit both forms
                try {
                    groupPresenter?.setIsLoading(true);
                    await submitNewUserForm();
                    await submitNewGroupForm();
                    window.location.href = `/dashboard/${userViewModel?.value.form.id}/users`;
                }
                catch (err) {
                    alertModal.value?.alert("エラーが発生しました。恐れ入りますが、再度お試しください。");
                }
                finally {
                    groupPresenter?.setIsLoading(false);
                }
            }
        }
        async function submitNewUserForm() {
            if (!viewModel?.value || !userViewModel?.value) {
                return;
            }
            const payload = {
                id: userViewModel?.value.form.id,
                name: userViewModel?.value.form.name,
                furigana: userViewModel?.value.form.furigana,
                phone: userViewModel?.value.form.phone,
                email: viewModel?.value.branchId ? userViewModel?.value.form.email : '',
            };
            await (0, registrationRequest_1.newUserPostRequest)(payload);
        }
        async function submitNewGroupForm() {
            if (!viewModel?.value || !groupViewModel?.value || !userViewModel?.value) {
                return;
            }
            if (viewModel.value.needHubspot) {
                groupPresenter?.createHubspotContact();
            }
            const payload = {
                name: groupViewModel.value.form.name,
                address: groupViewModel.value.form.address,
                category: groupViewModel.value.form.category,
                numOfExpectedUsers: groupViewModel.value.form.numOfExpectedUsers,
                numOfExpectedBranches: groupViewModel.value.form.numOfExpectedBranches,
                referrer: groupViewModel.value.form.referrer,
            };
            await (0, registrationRequest_1.newGroupPostRequest)(userViewModel?.value.form.id, payload, viewModel.value.selectedFeatures);
        }
        function scrollToInvalidInput() {
            const container = document.querySelector('.registration-slide[aria-hidden="false"]');
            if (!container) {
                return;
            }
            const invalidInput = container.querySelector('.input-error');
            if (!invalidInput) {
                return;
            }
            // Scroll the slide to the invalid input
            invalidInput?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
        function stepBarClass(n) {
            return {
                'left-step-bar': n === 1,
                'right-step-bar': n === TOTAL_STEPS,
            };
        }
        function barFillPercent(n) {
            const page = Math.min(Math.max(viewModel?.value.step ?? 1, 1), TOTAL_STEPS);
            const rel = page - (n - 1);
            if (rel <= 0) {
                return 0;
            }
            if (rel >= 1) {
                return 100;
            }
            return rel * 100;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createCommentVNode)(" Step Progress Bar "),
                ((0, vue_2.unref)(viewModel)?.isOwner)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createTextVNode)(" STEP " + (0, vue_2.toDisplayString)((0, vue_2.unref)(viewModel)?.step) + " OF " + (0, vue_2.toDisplayString)(TOTAL_STEPS) + " ", 1 /* TEXT */),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(TOTAL_STEPS, (n) => {
                                return (0, vue_2.createElementVNode)("div", {
                                    key: n,
                                    class: (0, vue_2.normalizeClass)(["step-bar mr-1", stepBarClass(n)])
                                }, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "step-fill",
                                        style: (0, vue_2.normalizeStyle)({ width: `${barFillPercent(n)}%` })
                                    }, null, 4 /* STYLE */)
                                ], 2 /* CLASS */);
                            }), 64 /* STABLE_FRAGMENT */))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)(["registeration-wrapper col-mx-auto flex-column", wrapperClass.value])
                }, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(["registration-slides", `page-${step.value}`])
                        }, [
                            (0, vue_2.createElementVNode)("section", {
                                class: "registration-slide p-1",
                                "aria-hidden": step.value !== 1
                            }, [
                                (0, vue_2.createVNode)(UserRegistrationForm_vue_1.default, {
                                    ref_key: "userFormRef",
                                    ref: userFormRef
                                }, null, 512 /* NEED_PATCH */)
                            ], 8 /* PROPS */, _hoisted_5),
                            ((0, vue_2.unref)(viewModel)?.isOwner)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", {
                                    key: 0,
                                    class: "registration-slide p-1",
                                    "aria-hidden": step.value !== 2
                                }, [
                                    (0, vue_2.createVNode)(GroupRegistrationForm_vue_1.default)
                                ], 8 /* PROPS */, _hoisted_6))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("section", {
                                class: "registration-slide p-1",
                                "aria-hidden": step.value !== 3
                            }, [
                                (0, vue_2.createVNode)(RegistrationData_vue_1.default)
                            ], 8 /* PROPS */, _hoisted_7)
                        ], 2 /* CLASS */)
                    ]),
                    (0, vue_2.createCommentVNode)(" Footer "),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (showPrevButton.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    class: "oplus-btn",
                                    onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(userPresenter)?.prevStep()))
                                }, [
                                    _hoisted_10,
                                    (0, vue_2.createTextVNode)(" 戻る ")
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-alt-btn col-ml-auto", loadingClass.value]),
                                onClick: submitForms
                            }, [
                                (showCompleteButton.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, " 登録 "))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                        (0, vue_2.createTextVNode)(" 続ける "),
                                        _hoisted_13
                                    ]))
                            ], 2 /* CLASS */)
                        ]),
                        (showCompleteButton.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                                (0, vue_2.createTextVNode)(" 「登録」をクリックすることにより"),
                                _hoisted_15,
                                (0, vue_2.createTextVNode)("と"),
                                _hoisted_16,
                                (0, vue_2.createTextVNode)("に同意されたものとします。 ")
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ])
                ], 2 /* CLASS */)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
